import { handleDefaultFormPreSave } from './default-form.handler';
import { handleEsitoValutazioneUVMPreSave } from './esito-valutazione-uvm-form.handler';
import { handleHospiceFormPreSave } from './hospice-form.handler';
import { handleModuloRivalutazioneHospicePreSave } from './modulo-rivalutazione-hospice-form.handler';
import { handleOspedaleDiComunitaPreSave } from './ospedale-di-comunita-form.handler';
import { handlePostAcuziePreSave } from './post-acuzie-form.handler';
import { handleSchedaAnamnesticaPreSave } from './scheda-anamnestica-form.handler';
import { handleSchedaAnamnesticaNonOspPreSave } from './scheda-anamnestica-non-osp-form.handler';
import { handleSchedaValutazionePreSave } from './scheda-valutazione-cp-form.handler';


export const formPreSaveHandlers: Record<string, any> = {
  'Scheda cure palliative hospice': handleHospiceFormPreSave,
  'Scheda Anamnestica': handleSchedaAnamnesticaPreSave,
  'Esito valutazione UVM': handleEsitoValutazioneUVMPreSave,
  'Scheda di prima valutazione nella rete cure palliative': handleSchedaValutazionePreSave,
  'Modulo rivalutazione Hospice': handleModuloRivalutazioneHospicePreSave,
  'Modulo segnalazione post acuzie': handlePostAcuziePreSave,
  'proposta per ammissione in ospedale di comunita': handleOspedaleDiComunitaPreSave,
  "Scheda Anamnestica per l'accesso al sistema delle cure intermedie, riabilitative e residenziali non ospedaliere": handleSchedaAnamnesticaNonOspPreSave,
  '*': handleDefaultFormPreSave
};
